export const LOCKED_SITES = {
    Loveme: 'chat',
    Natashaclub: 'chat',
    ForeignLadies: 'chat',
    Marriagency: 'chat',
    Generationlove: 'chat',
    Smartprogramm: 'chat',
    Myeasypartner: 'chat',
    Charmlive: 'mail',
    'Bride Forever': 'mail',
}
